module.exports = __webpack_public_path__ + "static/ic_like.8e4656df.png";